import React from 'react';
import './CasasVelasurBanner.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const proyectos = [
  {
    id: '',
    status: 'DISPONIBLE',
    statusType: 'disponible',
    ciudad: 'terreno1',
    ciudad1: 'construccion1',
    nombreKey: 'Magnolia',
    img: '/assets/Principal/Magnolia_Fachada.jpg',
  },
  {
    id: '',
    status: 'DISPONIBLE',
    statusType: 'disponible',
    ciudad: 'terreno2',
    ciudad1: 'construccion2',
    nombreKey: 'Olivo',
    img: '/assets/Principal/Olivo_Fachada.jpg',
  },
  {
    id: '',
    status: 'PRÓXIMAMENTE',
    statusType: 'proximamente',
    ciudad: 'terreno3',
    ciudad1: 'construccion3',//
    nombreKey: 'Begonia',
    img: '/assets/Principal/dalia.jpg',
  },
];

const CasasVelasurBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="proyectos-grid">
      {proyectos.map((p) => (
        <Link
          key={p.id}
          to={`/casas-velasur/${p.id}`}
          className="proyecto-card"
        >
          <div className="proyecto-card__image-wrapper">
            <img src={p.img} alt={t(p.nombreKey)} />
            <span
              className={`proyecto-card__badge proyecto-card__badge--${p.statusType}`}
            >
              {t(`casas.${p.statusType}`)}
            </span>
          </div>

          <div className="proyecto-card__info">
            <h3>{t(p.nombreKey)}</h3>
            <span className="proyecto-card__city">{t(`casas.${p.ciudad}`)}</span><br></br>
            <span className="proyecto-card__city">{t(`casas.${p.ciudad1}`)}</span>
          </div>
        </Link>
      ))}
    </section>
  );
};

export default CasasVelasurBanner;
